module.exports = __webpack_public_path__ + "img/phone-min.60647b01.png";